
import { Loader2 } from 'lucide-react'
import { ReactNode } from 'react'

import Error from '../../pages/common/Error'

import { cn } from '@/lib/utils'

interface Props {
  loading: boolean
  label?: string
  showError?: boolean
  error?: Error | null
  resetErrorBoundary?: () => void
  children: ReactNode
}

const Loading = ({
  loading,
  label,
  children,
  showError,
  error,
  resetErrorBoundary = () => {},
}: Props) => {
  return showError && error ? (
    <Error error={error} resetErrorBoundary={resetErrorBoundary} />
  ) : loading ? (
    <div className={cn('z-10 my-3 flex h-full w-full flex-col items-center justify-center')}>
      <div className="justify-content-center z-10 mt-5 flex">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
      <div className="justify-content-center mt-5 flex">
        <p>{label || 'Anwendung lädt...'}</p>
      </div>
    </div>
  ) : (
    children
  )
}

export default Loading
